import React from 'react'
import Footer from '../components/Footer'
import Accordion from 'react-bootstrap/Accordion';
import { Col, Container, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet';

function Blogs() {
    return (
        <>
            <Helmet>
                <title>Spot Your Leads | Real Estate Leads Guide  </title>
            </Helmet>
            <section className="blogsSec1">
                <Container>
                <h2>Blogs/FAQ</h2>

                    <Row>
                        <Col lg={6} md={6} sm={12} className="imgmob">
                            <div className='pricing-title'>
                                <h3>Introduction:</h3>
                                <h5>"Stay Informed. Stay Ahead. Master Your Real Estate Journey."</h5>
                                <p>
                                    Our blog is your go-to resource for real estate success, from expert tips to industry insights. Whether you're new to the market or a seasoned professional, you'll find valuable information to fuel your growth.
                                </p>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} className="imgmob">

                            <img src="images/8.png" alt="blogs" />

                        </Col>


                    </Row>
                </Container>
            </section>
            <section className="blogsec2">
                <h2>Sample Blog Topics
                </h2>
                <Container >
                    <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>"How to Effectively Use Real Estate Leads to Close More Deals"</Accordion.Header>
                            <Accordion.Body>
                                <ul>
                                    <li>1. "The Ultimate Guide to Filtering Leads for Maximum ROI"</li>
                                    <li>2. "Top Trends in the Real Estate Market You Should Know"</li>
                                    <li>3. "Success Stories: How Professionals Transformed Their Business
                                        with Spot Your Lead"</li>

                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>

                    </Accordion>
                </Container>
            </section>
            <section className="blogsec2">
                <h2>FAQ Section
                </h2>
                <Container >
                
                <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>What is Skiptracing?</Accordion.Header>
                            <Accordion.Body>
                                Skiptracing is a specialized process designed to locate individuals who have become challenging to find. By harnessing advanced data analytics, public records, and proprietary search techniques, skiptracing enables businesses to reconnect with elusive leads or debtors, ensuring you always have the right information at the right time.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>What does our platform provide?</Accordion.Header>
                            <Accordion.Body>
                                We provide an exclusive motivated sellers leads who are 100% ready to sell their properties. All lead info is gathered and validated through our quality control team before we go ahead and publish it on our platform.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>How many times can a single lead be purchased?</Accordion.Header>
                            <Accordion.Body>
                                All leads we post on our platform are completely exclusive for one single buyer. In case we come across the same lead again while dialing, our system automatically declines it, ensuring that the original buyer remains the only one who can dial and close the lead.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header>How can I start purchasing leads?</Accordion.Header>
                            <Accordion.Body>
                                You can simply top-up your wallet based on your needs—no obligatory packages or contracts required. Once your funds are received in your account balance, you can proceed with purchasing leads from our main tab.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4">
                            <Accordion.Header>How does SpotYourLeads generate leads?</Accordion.Header>
                            <Accordion.Body>
                                We generate our leads through actual phone calls and multiple social media advertisements that attract motivated sellers who call us directly. This ensures you receive high-quality leads.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="5">
                            <Accordion.Header>What guarantees me that the lead is not sold or under contract?</Accordion.Header>
                            <Accordion.Body>
                                We generate the leads via human interaction to ensure an exceptional experience. We collect data during our initial call, confirm that the property isn’t listed online, and verify that it’s not under contract before publishing it on our website.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="6">
                            <Accordion.Header>How can I raise a complaint about a lead that I purchased?</Accordion.Header>
                            <Accordion.Body>
                                You can reach out via email at <a href="mailto:support@spotyourleads.com">support@spotyourleads.com</a>. We will assist you within 24 hours, so please attach any supporting files to help with your case.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="7">
                            <Accordion.Header>How can I request a refund if the lead is no good?</Accordion.Header>
                            <Accordion.Body>
                                You can request a refund by emailing <a href="mailto:support@spotyourleads.com">support@spotyourleads.com</a>. If your case is valid, the balance will be credited to your SpotYourLeads account. Please attach any supporting files, such as a screenshot or call recording.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="8">
                            <Accordion.Header>Where can I see the leads I have purchased?</Accordion.Header>
                            <Accordion.Body>
                                You can view your purchased leads under the "My Dashboard" tab, where you can also update the status of each lead based on your interactions or progress.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="9">
                            <Accordion.Header>How do we set the pricing of each lead?</Accordion.Header>
                            <Accordion.Body>
                                Pricing is determined based on the market, asking price, and seller motivation. We guarantee that every lead's asking price is below market value and that the seller has a genuine motive to sell.
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                </Container>
            </section>

            <Footer />
        </>
    )
}

export default Blogs
